import React from 'react';
import Dialog from '@mui/material/Dialog';
import styles from './ai-dialog-shared/AiDialog.module.css';
import { useProductNameAiDialog } from './product-name-ai-dialog/useProductNameAiDialog';
import { DialogHeader } from './ai-dialog-shared/components/DialogHeader';
import { ContextDescription } from './ai-dialog-shared/components/ContextDescription';
import { PromptEditor } from './ai-dialog-shared/components/PromptEditor';
import { QuickPromptStyles } from './ai-dialog-shared/components/QuickPromptStyles';
import { SuggestionsArea } from './ai-dialog-shared/components/SuggestionsArea';
import { DialogFooter } from './ai-dialog-shared/components/DialogFooter';

const ProductNameAiDialog = (props) => {
  const {
    openProductNameDialog,
    setOpenProductNameDialog,
    setProductName,
    setSelectedTitle,
    title = '',
    productCategory = 'select',
    cuisineType = '',
  } = props;

  const {
    hasCategory,
    hasCuisine,
    predefinedPrompts,
    activePrompt,
    setActivePrompt,
    chosenTitle,
    isLoading,
    suggestions,
    errorMessage,
    chatResponseText,
    handleClose,
    handleSelectPrompt,
    handleGenerateTitles,
    handleChooseSuggestion,
    handleSelectTitle,
  } = useProductNameAiDialog({
    openProductNameDialog,
    setOpenProductNameDialog,
    setProductName,
    setSelectedTitle,
    title,
    productCategory,
    cuisineType,
  });

  return (
    <Dialog
      open={openProductNameDialog}
      className='alert-dialog-wrapper ai-product-name-dialog'
      maxWidth='md'
      // fullWidth
    >
      <div className={styles.body}>
        <DialogHeader title='AI Product Name Assistant' onClose={handleClose} />

        <ContextDescription
          introText='Fine-tune the AI prompt or pick one of the ready-made options below. We will use your current product name'
          trailingText='for better suggestions.'
          hasCategory={hasCategory}
          hasCuisine={hasCuisine}
          productCategory={productCategory}
          cuisineType={cuisineType}
        />

        <PromptEditor
          activePrompt={activePrompt}
          setActivePrompt={setActivePrompt}
          isLoading={isLoading}
          errorMessage={errorMessage}
          onGenerate={handleGenerateTitles}
          generateButtonLabel='Generate names'
          hasCategory={hasCategory}
          hasCuisine={hasCuisine}
          productCategory={productCategory}
          cuisineType={cuisineType}
        />

        <QuickPromptStyles
          predefinedPrompts={predefinedPrompts}
          activePrompt={activePrompt}
          onSelectPrompt={handleSelectPrompt}
        />

        <SuggestionsArea
          isLoading={isLoading}
          chatResponseText={chatResponseText}
          chatSuggestions={suggestions}
          selectedValue={chosenTitle}
          onChooseSuggestion={handleChooseSuggestion}
        />

        <DialogFooter
          selectedValue={chosenTitle}
          suggestions={suggestions}
          onClose={handleClose}
          onSelect={handleSelectTitle}
          selectButtonLabel='Select product name'
        />
      </div>
    </Dialog>
  );
};

export default ProductNameAiDialog;
